import { render, staticRenderFns } from "./logistics-info.vue?vue&type=template&id=eaf8ecec&scoped=true"
import script from "./logistics-info.vue?vue&type=script&lang=js"
export * from "./logistics-info.vue?vue&type=script&lang=js"
import style0 from "./logistics-info.vue?vue&type=style&index=0&id=eaf8ecec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf8ecec",
  null
  
)

export default component.exports